import { useTranslation } from 'react-i18next';

import InlineNotification from '~/components/InlineNotification/InlineNotification';

import styles from './styles.module.scss';

interface DokobitErrorHandlerProps {
  dokobitError?: { title: Nullable<string>; body: Nullable<string> };
}

export default function DokobitErrorHandler({
  dokobitError,
}: DokobitErrorHandlerProps) {
  const { t } = useTranslation();

  if (!dokobitError || !dokobitError.title || !dokobitError.body) {
    return null;
  }

  return (
    <div className={styles.errorHandler}>
      <InlineNotification
        variant="error"
        title={t(dokobitError.title)}
        description={t(dokobitError.body)}
      />
    </div>
  );
}
